import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { VendorsActionTypes } from './actions';
import { transformVendor } from '../transformations';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const vendorRatesReducer = createApiReducer(
  [
    VendorsActionTypes.FETCH_VENDORS_START,
    VendorsActionTypes.FETCH_VENDORS_SUCCESS,
    VendorsActionTypes.FETCH_VENDORS_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformVendor) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('vendor');
const addSearchReducer = createAddSearchReducer('vendor');
const updateSearchReducer = createUpdateSearchReducer('vendor');
const deleteSearchReducer = createDeleteSearchReducer('vendor');

const vendorChainedReducers = chainReducers(initialState, vendorRatesReducer);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  vendors: vendorChainedReducers,
  searches: searchChainedReducers,
});
